module.exports = __webpack_public_path__ + "static/media/icon-contact-collapsed-white.6bb64593.svg";